// extracted by mini-css-extract-plugin
export default {"mainDiv":"ModuleCards_mainDiv__ho6tX","isAdminmainDiv":"ModuleCards_isAdminmainDiv__nL4Lv"};